export default "__VITE_ASSET__BT_CIjO9__"